var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 29,
    viewBox: "0 0 129 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8 18.5L9 0.4H0V27.9H7.3V9.3L21.5 27.9H30V0.4H22.7V18.5H22.8Z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8 0C41.1 0 34.9 5.9 34.9 14.3C34.9 22.7 41.1 28.5 50.8 28.5C60.5 28.5 66.7 22.7 66.7 14.3C66.7 5.9 60.6 0 50.8 0ZM50.8 22.2C45.5 22.2 42.4 18.9 42.4 14.3C42.4 9.7 45.6 6.3 50.8 6.3C56 6.3 59.3 9.8 59.3 14.3C59.3 18.8 56.2 22.2 50.8 22.2Z",
    fill: "url(#paint1_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2 20.4L75 0.4H67.3L80.2 27.9H88.1L101.1 0.4H93.4L84.2 20.3V20.4Z",
    fill: "url(#paint2_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 28H121.3L118.9 22.8L116.2 16.9L111.9 8L107.6 16.9H107.7L104.9 22.8L102.4 28H94.8L107.9 0.4H115.9L129 28Z",
    fill: "url(#paint3_linear_1_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: -1.59,
    y1: -3.09,
    x2: 23.41,
    y2: 22.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2303C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0756B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 49.56,
    y1: -0.59,
    x2: 51.56,
    y2: 23.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F05967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E87B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED895C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 82.46,
    y1: -6.18,
    x2: 91.46,
    y2: 27.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F68F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F79656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 120.36,
    y1: 2.62,
    x2: 112.16,
    y2: 27.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F68D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F89F5F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 28.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaLogo);
export default __webpack_public_path__ + "static/media/NovaLogo.59ad1e7b9cb2f80077a7f19b35afee23.svg";
export { ForwardRef as ReactComponent };